import * as yup from 'yup';
export const CreateEnrollmentFormValidation = yup.object().shape({
  // isForeign: yup.boolean().default(false),
  user: yup.object().shape({
    name: yup.string().required('Nome é obrigatório'),
    isForeign: yup.boolean().default(false),
    bi: yup.string().required("Campo obrigatório")
      .when('isForeign', {
        is: true,
        then: schema => schema.required("Campo obrigatório"),
        otherwise: schema => schema.required('Campo obrigatório')
        .test('is-valid-document', 'Número do documento inválido', (value) => {
          if (!value) return false;

          // Conjuntos de regex para os documentos suportados
          const documentRegexes = [
            /^\d{12}[A-Za-z]$/, // BI: 12 dígitos seguidos de uma letra
            /^\d{12}$/, // BISlip: Apenas 12 dígitos
            /^[A-Z]{2}\d{8}$/, // DrivingLicense: 2 letras seguidas de 8 dígitos
            /^[A-Z]{2}\d{7}$/, // DrivingLicense: 2 letras seguidas de 8 dígitos
            /^[A-Z]{2}\d{9}$/, // DrivingLicense: 2 letras seguidas de 9 dígitos
            /^\d{13}$/, // VoterCard: 13 dígitos
          ];

          // O número deve passar em pelo menos um dos padrões
          return documentRegexes.some((regex) => regex.test(value));
        })
      //  .matches(/^\d{12}[A-Za-z]$/, 'Deve conter 12 dígitos seguidos de 1 letra')
        ,
      })
      ,
    nuit: yup.string().required('Nuit é obrigatório').matches(/^\d{9}$/, "Deve ter 9 digitos"),
    // optional()
    //    .when('isForeign', {
    //      is: true,
    //      then: schema => schema.nullable().optional(),
    //      otherwise: schema => schema.required('Nuit é obrigatório').matches(/^\d{9}$/, 'Deve ter 9 dígitos'),
    //    })
      
    email: yup.string().email('Email inválido'),
    phoneNumber: yup.string().matches(/^\d{9}$/, 'Número de telemóvel inválido').required('Número de telemóvel é obrigatório'),
    gender: yup.string().oneOf(['M', 'F'] as const, 'Gênero inválido').required('Gênero é obrigatório'),
    dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
      .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
      .test('is-past', 'Data de nascimento não pode ser no futuro',
        (value) => !value || new Date(value) <= new Date()),
    userName: yup.string(),
  }),
  documents: yup.array().of(
    yup.object().shape({
      id: yup.string().required('O ID do documento é obrigatório'),
      file: yup.mixed<File>()
        .required('O ficheiro é obrigatório')
        .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File)
    })
  ).defined(),
  enrollment: yup.object().shape({
    idCourse: yup.string().required("Selecione o curso"),
  }),
  idFaculty: yup.string().required("Unidade orgânica é obrigatória"),
  idDepartament: yup.string().required('Departamento é obrigatório'),
  idPlan: yup.string().required('Plano de curso é obrigatório'),
  subscribeStudent: yup.boolean().default(true),
  isInternStudent: yup.boolean().default(false),
  schoolCode: yup.string()
    .nullable() // Permite que o valor seja null ou undefined
    .notRequired() // Indica que o campo não é obrigatório
    // .matches(/^\d{2}\d{5}$|^\d{9}$/, 'O código da instituição deve ter o formato AA00001 ou AA0000000')
    // .test(
    //   'is-valid-code',
    //   'O código da instituição deve ter o formato AA00001 ou 192131789 se AA0000000',
    //   (value) => !value || /^\d{2}\d{5}$/.test(value) || /^\d{9}$/.test(value) // Só valida se o valor for preenchido
    // )
    ,
  // schoolCode: yup.string()
  //   .nullable() // Permite que o valor seja null ou undefined
  //   .notRequired() // Indica que o campo não é obrigatório
  //   .matches(/^\d{2}\d{5}$/, 'O código da instituição deve ter o formato AA00001')
  //   .test(
  //     'is-valid-code',
  //     'O código da instituição deve ter o formato AA00001 se fornecido',
  //     (value) => !value || /^\d{2}\d{5}$/.test(value) // Só valida se o valor for preenchido
  //   ),
  year: yup.number().typeError("Deve ser um número")
    .positive('Deve ser maior que zero'),
  semester: yup.number().typeError("Deve ser um número")
    .positive('Deve ser maior que zero')
    .oneOf([1, 2], 'Semestre deve ser 1 ou 2')
  ,
});